





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import TransactionalFeesDialogForm from '@/components/Products/ProductFees/Transactional/TransactionalFeesDialogForm.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import CreateTransactionalFeeRequest from '@/models/Products/ProductFees/CreateTransactionalFeeRequest';

@Component({ name: 'TransactionalFeesCreateDialog', components: { TransactionalFeesDialogForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    transactionalFeeRequest: CreateTransactionalFeeRequest = new CreateTransactionalFeeRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.transactionalFeeRequest = new CreateTransactionalFeeRequest();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.createTransactionalFee(this.transactionalFeeRequest);
        }
    }

}
